import React, { useEffect, useState } from "react";
import { VscChromeClose } from "react-icons/vsc";
import { useSelector } from "react-redux";
import { BsSliders } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { brandByModel } from "../utils/brandsData";
import { FiSearch } from "react-icons/fi";
import { useMediaQuery } from "react-responsive";
import { Typeahead } from "react-bootstrap-typeahead";

const FilterForm = () => {
  const productState = useSelector((state) => state?.product?.product);

  const [productOpt, setProductOpt] = useState([]);
  const [paginate, setPaginate] = useState(true);

  const [vehicleBrand, setVehicleBrand] = useState("");
  const [brandModel, setBrandModel] = useState("");
  const [year, setYear] = useState("");
  const [selectedEngineSize, setSelectedEngineSize] = useState("");
  const [selectedBudget, setSelectedBudget] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const isDesktop = useMediaQuery({ minWidth: 768 });

  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search");

  const handleBrandChange = (e) => {
    setVehicleBrand(e.target.value);
    setBrandModel("");
  };

  const handleBudgetFilter = (min, max) => {
    setSelectedBudget([min, max]);
  };
 

  const handleEngineSizeFilter = (size) => {
    setSelectedEngineSize(size);
    document.body.style.overflow = "auto";
  };

  // Clear All Filters
  const clearAllFilters = () => {
    setVehicleBrand("");
    setBrandModel("");
    setYear("");
    setSelectedEngineSize("");
    setSelectedBudget(null);

    const queryParams = new URLSearchParams(location.search);
    const paramsToRemove = [
      "vehicle_brand",
      "brand_model",
      "year_of_manufacture",
      "engine_size",
      "price__gte",
      "price__lte",
      "sort",
    ];

    paramsToRemove.forEach((param) => queryParams.delete(param));
    navigate(`/search?${queryParams.toString()}`, { replace: true });
  };

  // Extract unique engine sizes from products
const engineSizes = [
  ...new Set(
    productState
      .flatMap((product) =>
        Array.isArray(product.engineSize)
          ? product.engineSize.map((e) => e.title)
          : []
      )
  ),
].filter(Boolean); // remove null/undefined

  // Sync Form with URL Params
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    setVehicleBrand(queryParams.get("vehicle_brand") || "");
    setBrandModel(queryParams.get("brand_model") || "");
    setYear(queryParams.get("year_of_manufacture") || "");
    setSelectedEngineSize(queryParams.get("engine_size") || "");

    const minPrice = queryParams.get("price__gte");
    const maxPrice = queryParams.get("price__lte");

    if (minPrice && maxPrice) {
      setSelectedBudget([Number(minPrice), Number(maxPrice)]);
    }
  }, [location.search]);

  // Remove query parameter from URL
  const removeQueryParam = (param) => {
    const queryParams = new URLSearchParams(location.search);

    if (param === "budget") {
      queryParams.delete("price__gte");
      queryParams.delete("price__lte");
    } else if (param === "engine_size") {
      queryParams.delete("engine_size");
    } else if (param === "year") {
      queryParams.delete("year_of_manufacture");
    } else if (param === "model") {
      queryParams.delete("brand_model");
    } else {
      queryParams.delete(param);
    }

    navigate(`/search?${queryParams.toString()}`, { replace: true });
  };

  // Handle Submit (apply filters)
  const handleSubmit = (e) => {
    e.preventDefault();

    const params = {
      vehicle_brand: vehicleBrand || undefined,
      brand_model: brandModel || undefined,
      year_of_manufacture: year || undefined,
      engine_size: selectedEngineSize || undefined,
      price__gte: selectedBudget ? selectedBudget[0] : undefined,
      price__lte: selectedBudget ? selectedBudget[1] : undefined,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== "")
    );

    navigate(`/search?${new URLSearchParams(filteredParams).toString()}`, {
      replace: true,
    });
  };

  // Search suggestions
  useEffect(() => {
    const query = searchQuery ? searchQuery.toLowerCase() : "";
    const suggestions = new Set(productOpt);

    productState.forEach((item) => {
      const titleWords = item.title.toLowerCase().split(" ");
      const brand = item.brand ? item.brand.toLowerCase() : "";

      if (brand.includes(query)) suggestions.add(brand);
      if (item.title.toLowerCase().includes(query)) suggestions.add(item.title);
      if (item.type && item.type.toLowerCase().includes(query)) suggestions.add(item.type);

      titleWords.forEach((word) => {
        if (word.includes(query)) suggestions.add(word);
      });
    });

    setProductOpt(Array.from(suggestions));
  }, [productState, searchQuery]);

  const handleSuggestionSelect = (selected) => {
    if (selected.length > 0) {
      navigate(`/warehouse?search=${selected[0]}`);
    }
  };

 
  return (
    <>
      <div className="search__vehicles-main-wrapper">

        {/* Mobile Search */}
        {!isDesktop && (
          <div className="search-vehicle">
            <Typeahead
              id="mobile-vehicle-search"
              onChange={handleSuggestionSelect}
              options={productOpt}
              paginate={paginate}
              labelKey={"name"}
              minLength={2}
              className="search-box"
              placeholder="Search vehicle..."
            />
            <FiSearch className="search-icon" />
          </div>
        )}

        <form onSubmit={handleSubmit} className="filter-nav">

          {/* Brand */}
          <div className="filter-nav-item">
            <div className="dropdown-content">
              <select className="form-select" value={vehicleBrand} onChange={handleBrandChange}>
                <option value="">Select Brand</option>
                {Object.keys(brandByModel).map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Model */}
          <div className="filter-nav-item">
            <div className="dropdown-content">
              <select
                className="form-select"
                value={brandModel}
                onChange={(e) => setBrandModel(e.target.value)}
                disabled={!vehicleBrand}
              >
                <option value="">Select Model</option>
                {brandByModel[vehicleBrand]?.map((model, index) => (
                  <option key={index} value={model}>
                    {model}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Year */}
          <div className="filter-nav-item">
            <div className="dropdown-content">
              <select className="form-select" value={year} onChange={(e) => setYear(e.target.value)}>
                <option value="">Select Year</option>
                {Array.from(
                  new Set(productState?.map((item) => item.yom).filter(Boolean))
                )
                  .sort((a, b) => b - a)
                  .map((yr, index) => (
                    <option key={index} value={yr}>
                      {yr}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          {/* Engine Size */}
          <div className="filter-nav-item">
            <div className="dropdown-content">
              <select
                className="form-select"
                value={selectedEngineSize}
                onChange={(e) => handleEngineSizeFilter(e.target.value)}
              >
                <option value="">Select Engine Size</option>
                {engineSizes
                  .sort((a, b) => {
                    const numA = parseInt(a.replace(/\D/g, ""), 10);
                    const numB = parseInt(b.replace(/\D/g, ""), 10);
                    return numA - numB;
                  })
                  .map((size, i) => (
                    <option key={i} value={size}>
                      {size}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          {/* Budget */}
          <div className="filter-nav-item">
            <div className="dropdown-content">
              <select
                className="form-select"
                value={selectedBudget ? `${selectedBudget[0]}-${selectedBudget[1]}` : ""}
                onChange={(e) => {
                  const [min, max] = e.target.value.split("-").map(Number);
                  handleBudgetFilter(min, isNaN(max) ? Infinity : max);
                }}
              >
                <option value="">Select Budget</option>
                <option value="0-500000">0-500K</option>
                <option value="500000-1000000">500K-1M</option>
                <option value="1000000-2000000">1M-2M</option>
                <option value="2000000-3000000">2M-3M</option>
                <option value="3000000-5000000">3M-5M</option>
                <option value="5000000-10000000">5M-10M</option>
                <option value="10000000-Infinity">Above 10M</option>
              </select>
            </div>
          </div>

          <button type="submit" className="btn search-btn">
            <BsSliders /> Filter
          </button>
        </form>

        {/* Selected Filters */}
        {(vehicleBrand || brandModel || year || selectedEngineSize || selectedBudget) && (
          <div className="selected-filters">
            <ul>
              {vehicleBrand && (
                <li>
                  Brand: {vehicleBrand}
                  <button className="close-btn" onClick={() => { setVehicleBrand(""); removeQueryParam("vehicle_brand"); }}>
                    <VscChromeClose />
                  </button>
                </li>
              )}

              {brandModel && (
                <li>
                  Model: {brandModel}
                  <button className="close-btn" onClick={() => { setBrandModel(""); removeQueryParam("model"); }}>
                    <VscChromeClose />
                  </button>
                </li>
              )}

              {year && (
                <li>
                  Year: {year}
                  <button className="close-btn" onClick={() => { setYear(""); removeQueryParam("year"); }}>
                    <VscChromeClose />
                  </button>
                </li>
              )}

              {selectedEngineSize && (
                <li>
                  Engine Size: {selectedEngineSize}
                  <button className="close-btn" onClick={() => { setSelectedEngineSize(""); removeQueryParam("engine_size"); }}>
                    <VscChromeClose />
                  </button>
                </li>
              )}

              {selectedBudget && (
                <li>
                  Budget: {selectedBudget[0].toLocaleString()} –{" "}
                  {selectedBudget[1] === Infinity ? "Above" : selectedBudget[1].toLocaleString()}
                  <button className="close-btn" onClick={() => { setSelectedBudget(null); removeQueryParam("budget"); }}>
                    <VscChromeClose />
                  </button>
                </li>
              )}
            </ul>

            <button className="clear-btn" onClick={clearAllFilters}>
              <VscChromeClose /> Clear All
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default FilterForm;
